import { UserChoices } from '../../shared/types/user-choices';

import { PaymentPlanReducerAction, PaymentPlanReducerTypes } from './types';

export function bookingDetailsReducer(
    state: UserChoices,
    action: PaymentPlanReducerAction
): UserChoices {
    switch (action.type) {
        case PaymentPlanReducerTypes.SET_NUMBER_OF_STUDENTS:
            return action.data === state.numberOfStudents
                ? state
                : {
                      ...state,
                      numberOfStudents: action.data,
                  };
        case PaymentPlanReducerTypes.SET_INSTALMENT_ID:
            return action.data === state.instalmentId
                ? state
                : {
                      ...state,
                      instalmentId: action.data,
                  };
        case PaymentPlanReducerTypes.SET_INSTALMENT_TYPE:
            return action.data === state.instalmentType
                ? state
                : {
                      ...state,
                      instalmentType: action.data,
                  };
        case PaymentPlanReducerTypes.SET_TERM:
            return action.data === state.term
                ? state
                : {
                      ...state,
                      term: action.data,
                  };
        default:
            return state;
    }
}
